import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute, Params, UrlTree, Data } from '@angular/router';

import { ApiService } from '../services/api.service';
import { AuthService } from '../services/auth.service';
import { LocaleService } from '../services/locale.service';
import { NumbersService } from '../services/numbers.service';
import { SnackService } from '../services/snack.service';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { HttpClient } from '@angular/common/http';
@Component({
	selector: 'app-confirmation-otp',
	templateUrl: './confirmation-otp.component.html',
	styleUrls: ['./confirmation-otp.component.scss'],
})
export class ConfirmationOtpComponent implements OnInit {
	loading: boolean = false;

	showResendOTP: boolean = false;
	showphone: boolean = false;
	showResendOTPTimer: number;
	data: any;
	user: any;
	canExit: boolean = false;
	visible: boolean = false;
	public recaptchaVerifier: firebase.auth.RecaptchaVerifier;
	recaptchaWidgetId: number;
	redirect: string;
	assignAd: string;
	embedded: string;
	verification: any = '';
	confirmationResult: firebase.auth.ConfirmationResult;
	selectedCountryPrefix: any = [];
	filterselectedCountryPrefix: any = [];
	phoneNumber: any;
	phonePrefix: any;
	bodyy: any;
	invalidPhone = false;
	validMobile = true;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private snack: SnackService,
		public api: ApiService,
		private title: Title,
		private numbers: NumbersService,
		public auth: AuthService,
		public locale: LocaleService,
		private dialog: MatDialog,
		private cdf: ChangeDetectorRef,
		private httpClient: HttpClient
	) {}

	form: UntypedFormGroup = new UntypedFormGroup({
		otp: new UntypedFormControl('', Validators.required),
		phonePrefix: new UntypedFormControl(localStorage.getItem('prefix'), Validators.required),
		phoneNumber: new UntypedFormControl('', Validators.required),
	});

	onPhoneKeyUp() {
		if (this.form.get('phoneNumber').value !== null) {
			this.form.get('phoneNumber').setValue(this.numbers.toNumeric(this.form.get('phoneNumber').value.toString().replace(/\s/g, '')));

			if (this.form.get('phoneNumber').value.toString().charAt(1) === '0') {
				this.form
					.get('phoneNumber')
					.setValue(this.form.get('phoneNumber').value.toString().slice(0, 1) + this.form.get('phoneNumber').value.toString().slice(2));
			}
			if (this.form.get('phoneNumber').value.toString().charAt(0) !== '0') {
				this.form.get('phoneNumber').setValue('0' + this.form.get('phoneNumber').value.toString());
			}
			if (this.form.get('phoneNumber').value.length < 10 || this.form.get('phoneNumber').value.length > 15) {
				this.validMobile = false;
			} else {
				this.validMobile = true;
			}
		}
	}

	setTimeoutResendOTP() {
		setTimeout(() => {
			this.showResendOTP = true;
		}, 60000);

		this.showResendOTPTimer = 60;
		let timer = setInterval(() => {
			this.showResendOTPTimer = this.showResendOTPTimer - 1;
			if (this.showResendOTPTimer === 0) {
				this.showResendOTP = true;
				this.showphone = true;
				this.showResendOTPTimer = undefined;
				clearInterval(timer);
			}
		}, 1000);
	}

	resendOTP(showSnack: boolean = true) {
		this.showResendOTP = false;
		this.loading = true;
		this.showphone = false;

		this.sendOtp();
	}

	//fctn to enter only digits
	isNumberKey(evt) {
		let charCode = evt.which ? evt.which : evt.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			if (!document.getElementById('otp')) {
				this.validMobile = false;
			}

			return false;
		}
		return true;
	}

	ngOnInit(): void {
		this.loading = true;
		this.title.setTitle(this.locale.translations['user']['user-verify']['n232'] + ' | ' + this.locale.translations['header']['n0']);

		this.route.queryParams.subscribe((queries: Params) => {
			if (queries['redirect'] !== undefined) {
				this.redirect = queries['redirect'];
			}

			if (queries['from']) {
				this.redirect = queries['from'];
			}

			if (queries['id'] !== undefined) {
				this.assignAd = queries['id'];
			}
			if (queries['embedded'] !== undefined) {
				this.embedded = queries['embedded'];
			}
		});

		this.httpClient.get<any>('./assets/country_dial_info.json').subscribe((data) => {
			this.selectedCountryPrefix = data;
			this.filterselectedCountryPrefix = data;
		});

		this.OtpTrigger();
	}

	fire() {
		this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('sign-in-button', {
			size: 'invisible',
		});

		this.data = this.auth.user()['phone'];
		this.sendOtp();
	}

	sendOtp() {
		this.loading = true;
		firebase
			.auth()
			.signInWithPhoneNumber(localStorage.getItem('prefix') + this.data.toString(), this.recaptchaVerifier)
			.then((confirmationResult) => {
				this.confirmationResult = confirmationResult;

				this.loading = false;
				this.setTimeoutResendOTP();
			})
			.catch((err) => {
				this.invalidPhone = true;
				if (err['code'] == 'auth/too-many-requests') {
					this.snack.open(this.locale.translations['user']['user-verify']['n270']);

					this.showResendOTP = true;
					this.showphone = true;
				} else {
					this.snack.open(this.locale.translations['misc']['n174']);
				}

				this.loading = false;
			});
	}

	checkOtp() {
		let originalOtp = this.form.controls['otp'].value;
		this.confirmationResult
			.confirm(originalOtp)
			.then((user) => {
				this.loading = true;
				const verify_body: FormData = new FormData();
				verify_body.append('lang', this.locale.lang);
				verify_body.append('userID', this.auth.user()['userID']);
				verify_body.append('altPhone', this.data);

				this.api.verifyPhone(verify_body).subscribe((res) => {
					if (res['status'] === '1') {
						this.showResendOTP = false;
						this.loading = true;
						this.snack.open(this.locale.translations['logup']['login']['s8']);

						if (this.redirect !== undefined) {
							this.router.navigate(['/' + this.redirect], {
								queryParams: {
									embedded: this.embedded,
								},
							});
						}

						if (this.redirect !== undefined && this.assignAd !== undefined) {
							this.router.navigate(['/' + this.redirect + '/' + this.assignAd], {
								queryParams: {
									embedded: this.embedded,
								},
							});
						} else {
							this.router.navigate([this.redirect === undefined ? '/user/' + this.auth.user()['userID'] + '/ads' : '/' + this.redirect], {
								queryParams: {
									from: this.redirect === 'placead' ? 'login' : undefined,
									embedded: this.embedded,
								},
							});
						}
					} else {
						originalOtp = null;
					}
				});
			})
			.catch((err) => {
				this.snack.open(this.locale.translations['user']['user-verify']['n238']);
				this.loading = false;
			});
	}

	onToggle() {
		this.visible = true;
	}

	onLogout() {
		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			width: '250px',
			height: '120px',
			data: {
				message: this.locale.translations['user']['user-ads']['delete-ad']['n88'],
				yes: this.locale.translations['user']['user-ads']['delete-ad']['n89'],
				no: this.locale.translations['user']['user-ads']['delete-ad']['n90'],
			},
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result === true) {
				this.auth.logout();

				this.router.navigate(['/'], {
					queryParams: {
						session: 'closed',
					},
				});

				this.snack.open(this.locale.translations['logup']['login']['s13']);
			}
		});
	}

	changePhone() {
		if (this.form.controls['phoneNumber'].value.toString().length < 10) {
			this.snack.open(this.locale.translations['logup']['signup']['n231']);
		}

		const body: FormData = new FormData();
		body.append('lang', this.locale.lang);
		body.append('phone', this.form.controls['phoneNumber'].value);

		this.api.PhoneRegistered(body).subscribe((res) => {
			if (res['response']['phoneRegistered'] === '1') {
				this.snack.open(this.locale.translations['user']['user-process']['s23']);
			} else {
				this.bodyy = this.auth.user();
				this.bodyy.phone = this.form.controls['phoneNumber'].value;
				localStorage.setItem('prefix', this.form.controls['phonePrefix'].value);
				localStorage.setItem('user', JSON.stringify(this.bodyy));
				this.visible = false;
				this.showResendOTP = false;
				this.showphone = false;
				this.cdf.detectChanges();
				this.recaptchaVerifier.clear();
				this.OtpTrigger();
			}
		});
	}

	onSelect(id: string) {
		localStorage.setItem('prefix', id);
	}

	onKey(value) {
		value == '' ? (this.filterselectedCountryPrefix = this.selectedCountryPrefix) : (this.filterselectedCountryPrefix = this.search(value));
	}

	search(value: string) {
		let filter = value.toLowerCase();
		return this.selectedCountryPrefix.filter((option) => option.name.toLowerCase().includes(filter));
	}

	canDeactivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (!this.form.dirty || this.canExit) {
			return true;
		}

		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			width: '250px',
			height: '120px',
			data: {
				message: this.locale.translations['place-ad']['n162'],
				yes: this.locale.translations['user']['user-ads']['delete-ad']['n89'],
				no: this.locale.translations['user']['user-ads']['delete-ad']['n90'],
			},
		});

		return dialogRef.afterClosed();
	}

	OtpTrigger() {
		setTimeout(() => {
			this.fire();
		}, 500);
	}
}
